import { gql } from "@apollo/client";

export const CREATE_SHOP_ADDRESS = gql`
mutation CreateShopAddress($data: shopAddressDataInput!) {
    createShopAddress(data: $data) {
      message
    }
  }
`;

export const ADD_SHOP_ADDRESS_VALIDATE = gql`
mutation AddShopAddress($data: shopAddressDataInput!) {
    addShopAddress(data: $data) {
      message
    }
  }
`;

export const PUT_SHOP_ADDRESS = gql`
  mutation PutShopAddress($where: ShopAddressWhereInput!, $data: shopAddressDataInput!) {
    putShopAddress(where: $where, data: $data) {
      message
    }
  }
`;

export const DELETE_SHOP_ADDRESS = gql`
mutation DelShopAddress($where: ShopAddressWhereInput!) {
  delShopAddress(where: $where) {
    message
  }
}
`;

export const UPDATE_DEFAULT_SHOP_ADDRESS = gql`
mutation UpdateShopAddressDefault($where: ShopAddressWhereInput!, $data: shopAddressDataInput!) {
  updateShopAddressDefault(where: $where, data: $data) {
    message
  }
}
`;